export default __webpack_public_path__ + "static/media/xlsDownload.90a33510.png";